import {figmaElement} from "../figma-tree";
type ArchiveButtonProps = {
  className?: string;
  label?: string;
  state?: "Default";
  style?: "Primary" | "Secondary";
};

function ArchiveButton({ className, label = "强制通过", state = "Default", style = "Primary" }: ArchiveButtonProps) {
  const isSecondaryAndDefault = style === "Secondary" && state === "Default";
  return (
    <div className={className || `border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] w-[104px] ${isSecondaryAndDefault ? "border border-[var(--action-secondary,#626b78)]" : "border-[1.5px] border-[var(--archive-action-primary,#29465b)]"}`} id={isSecondaryAndDefault ? "node-8_13" : "node-8_5"}>
      {style === "Primary" && state === "Default" && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-action-primary,#29465b)] whitespace-nowrap" data-node-id="8:6">
          {label}
        </p>
      )}
      {isSecondaryAndDefault && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--action-secondary,#626b78)] whitespace-nowrap" data-node-id="8:14">
          {label}
        </p>
      )}
    </div>
  );
}

export default function Component49Prompt() {
  return (
    <div className="bg-[var(--archive-bg-surface,white)] border border-[var(--archive-border-default,#e1e5eb)] border-solid content-stretch flex flex-col gap-[var(--archive-space-24,24px)] items-start overflow-clip p-[var(--archive-space-32,32px)] relative rounded-[var(--archive-radius-8,8px)] size-full" data-node-id="193:1514" data-name="49 / 确认发布 Prompt">
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Bold'] font-bold leading-[28px] relative shrink-0 text-[20px] text-[color:var(--archive-text-primary,#20242c)] whitespace-nowrap" data-node-id="193:1515">
        发布保存的 Prompt？
      </p>
      <div className="[word-break:break-word] font-['Noto_Sans_SC:Regular'] font-normal leading-[0] relative shrink-0 text-[14px] text-[color:var(--archive-text-secondary,#8a929f)] w-[536px] whitespace-pre-wrap" data-node-id="193:1516">
        <p className="leading-[24px] mb-0">该版本已保存，可直接发布，无需样本测试。</p>
        <p className="leading-[24px] mb-0">修改说明：按本次保存版本显示</p>
        <p className="leading-[24px] mb-0">​</p>
        <p className="leading-[24px] mb-0">请确认发布此保存版本。</p>
        <p className="leading-[24px]">发布后仅影响新提交的审核任务，进行中任务与历史案件保持原版本。</p>
      </div>
      <div className="content-stretch cursor-pointer flex gap-[var(--archive-space-16,16px)] h-[44px] items-start justify-end overflow-clip relative shrink-0 w-[536px]" data-node-id="193:1517" data-name="Actions">
        <ArchiveButton className="border border-[var(--action-secondary,#626b78)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[96px]" label="取消" style="Secondary" />
        <ArchiveButton className="border-[1.5px] border-[var(--archive-action-primary,#29465b)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[160px]" label="确认发布" />
      </div>
    </div>
  );
}
